import { render, staticRenderFns } from "./jifenList.vue?vue&type=template&id=56b5a936&scoped=true&"
import script from "./jifenList.vue?vue&type=script&lang=js&"
export * from "./jifenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5a936",
  null
  
)

export default component.exports